import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Mail, User, Video } from "lucide-react";

const SAMPLE = {
  name: "Priya Sharma",
  join_url: "https://us02web.zoom.us/w/xf9ktz3q",
  title: "Sell your first cohort in 30 days",
};

function render(text, extra = {}) {
  let out = text || "";
  const vars = { ...SAMPLE, ...extra };
  Object.entries(vars).forEach(([k, v]) => {
    out = out.replace(new RegExp(`{{\\s*${k}\\s*}}`, "g"), v);
  });
  return out;
}

export function EmailPreviewButton({ template, ruleName, hostName = "Ravi", brand = "Videoepreneur", children }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="vp-btn-ghost text-xs py-1.5 px-3 inline-flex items-center gap-1"
              data-testid={`email-preview-${ruleName}`}>
        <Mail className="w-3.5 h-3.5" strokeWidth={1.5} /> {children || "Preview email"}
      </button>
      <EmailPreviewModal open={open} onOpenChange={setOpen} template={template} ruleName={ruleName} hostName={hostName} brand={brand} />
    </>
  );
}

export default function EmailPreviewModal({ open, onOpenChange, template, ruleName, hostName = "Ravi", brand = "Videoepreneur" }) {
  const subject = render(template?.subject);
  const body = render(template?.body);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border border-[#E4E6EC] text-[#0B0D17] max-w-2xl p-0 overflow-hidden">
        <DialogHeader className="p-5 border-b border-[#E4E6EC]">
          <DialogTitle className="font-display text-lg font-bold flex items-center gap-2">
            <Mail className="w-4 h-4 text-[#0B5CFF]" /> Email preview · <span className="text-[#4A4D57] font-normal capitalize">{ruleName?.replace(/_/g, " ")}</span>
          </DialogTitle>
        </DialogHeader>

        {/* Fake email client header */}
        <div className="px-6 py-4 bg-[#F6F7FA] border-b border-[#E4E6EC] text-sm">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-[#0B5CFF] flex items-center justify-center">
              <Video className="w-4 h-4 text-white" strokeWidth={1.75} />
            </div>
            <div className="flex-1">
              <div className="font-semibold">{hostName} <span className="text-[#747680] font-normal">via {brand}</span></div>
              <div className="text-xs text-[#4A4D57]">to <span className="text-[#0B0D17]">priya@example.com</span></div>
            </div>
            <div className="text-xs text-[#747680]">just now</div>
          </div>
          <div className="mt-3 font-display text-lg font-bold">{subject || "(no subject)"}</div>
        </div>

        {/* Rendered body */}
        <div className="px-6 py-6 bg-white max-h-[440px] overflow-auto">
          <div className="whitespace-pre-wrap text-[15px] leading-relaxed text-[#0B0D17]">
            {body || "(empty template)"}
          </div>
          <div className="mt-6">
            <a href={SAMPLE.join_url} target="_blank" rel="noreferrer" className="vp-btn-primary inline-flex items-center gap-2">
              <Video className="w-4 h-4" strokeWidth={1.75} /> Join webinar
            </a>
          </div>
        </div>

        {/* Footer branding */}
        <div className="px-6 py-4 bg-[#F6F7FA] border-t border-[#E4E6EC] text-xs text-[#747680] flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <User className="w-3.5 h-3.5" strokeWidth={1.5} />
            Sample data: {SAMPLE.name} · {SAMPLE.title}
          </div>
          <div>Sent by {brand}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
